export const MM_PER_INCH = 25.4;
export const FOOT_LB_F_PER_NEWTON_METER = 0.73756214927;
export const MEGAPASCALS_PER_PSI = 0.0068947573;
export const POUND_FORCE_PER_KILONEWTON = 224.80894;